import cloneDeep from 'lodash/cloneDeep'

export const capitalize = (str?: string) => {
  if (!str) return `${str}`
  return str.charAt(0).toUpperCase() + str.slice(1)
}

type JsonType =
  | string
  | number
  | boolean
  | null
  | undefined
  | { [key: string]: JsonType }
  | JsonType[]
  | unknown

const concat = <T>(
  object: T,
  path: string,
  keys: string[],
  pos: 'before' | 'after',
  str: string
): T => {
  if (typeof object === 'string') {
    for (const key of keys) {
      if (path.endsWith(key)) {
        // Not sure why this "as" is needed
        return (pos === 'before' ? str + object : object + str) as T
      }
    }
    return object
  }
  if (object == null || typeof object !== 'object') {
    return object
  }

  if (Array.isArray(object)) {
    for (let i = 0; i < object.length; i++) {
      object[i] = concat(object[i], `${path}[${i}]`, keys, pos, str)
    }
    return object
  }

  for (const k in object) {
    object[k] = concat(object[k], `${path}.${k}`, keys, pos, str)
  }
  return object
}

// generic mapper that injects str to specified key of object
export const concatStrToAllKeys = <T extends JsonType>({
  object,
  keys,
  str,
  position = 'before',
}: {
  object: T
  keys: string[]
  str: string
  position?: 'before' | 'after'
}): T => {
  const cloned = cloneDeep(object)
  return concat(cloned, '', keys, position, str)
}

export const refineCommaInput = (v: string) => v.replace(',', '.')
